var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9998 4.93805L8.3398 1.97805C9.4798 1.33805 11.3398 1.33805 12.4898 1.97805L17.8298 4.94805C19.0398 5.61805 20.0298 7.29805 20.0298 8.67805V14.328C20.0298 15.708 19.0398 17.388 17.8298 18.058C16.0398 19.048 14.2798 20.188 12.4198 21.028C11.1598 21.598 9.5898 21.718 8.3398 21.028L2.9998 18.058C1.7898 17.388 0.799805 15.708 0.799805 14.328V8.66805C0.799805 7.28805 1.7898 5.60805 2.9998 4.93805Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4102 20.568V11.498",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60938 6.38818L10.4394 11.4982L19.2094 6.41818",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8293 15.9779L17.2893 14.5079L15.8193 14.0479",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8994 16.7976L17.1794 14.5776",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengthIcon);
export default __webpack_public_path__ + "static/media/length-icon.fab25770217bd4e95924b10735e74314.svg";
export { ForwardRef as ReactComponent };